// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"2c777b74","651":"2c777b74","767":"2c777b74","790":"2c777b74","925":"2c777b74"}[chunkId] + ".chunk.css";
};